module.exports = __webpack_public_path__ + "img/TruPath-6.c6731b15.jpg";